import HttpClient from "../HttpClient";
import ConstructSequelizeFilters from "../utils/ConstructSequelizeFilters";
import axios from "axios";

export class PromotionalBalanceService {
    async getAllPromotionalBalance(
        limit: number,
        offset: number,
        filters: any,
        sort: any,
      ) {
        let nullFilters: string[] = [];
        let notNullFilters: string[] = [];
        let filter = ConstructSequelizeFilters(filters, ['cohortName'], ['walletId','paymentStatus','status'], nullFilters, notNullFilters);
        filters = {
          ...filter,
        }
        let data = await HttpClient.get("/wallet/centaurus/promotional-balance", {
          params: {
            limit,
            offset,
            filters,
            sort,
          },
        });
        return {
          data: data?.data?.data,
          total: data?.data?.count,
        };
      }

      async getAllPromotionalBalanceForUser(
        walletId: number,
        limit: number,
        offset: number,
        sort: any,
      ) {
        let filter = {"walletId": walletId};
        let filters = ConstructSequelizeFilters(filter, [], ['walletId']);
        let data = await HttpClient.get("/wallet/centaurus/promotional-balance", {
          params: {
            limit,
            offset,
            filters,
            sort,
          },
        });
        return data?.data;
      }

      async getPromotionalBalanceById(id: number) {
        let data = await HttpClient.get(`/wallet/centaurus/promotional-balance/${id}`);
        return data;
    }

    async expireWalletCash(balanceId: number){
        let data = await HttpClient.delete(`/wallet/centaurus/promotional-balance/${balanceId}`); 
        return data
    }

    async addWalletCash(payload: any){
        let data = await HttpClient.post(`/wallet/centaurus/add-wallet-cash`,payload);
        return data
    }

    async initiateRefund(balanceId: number, payload: { reason: string; refundType: string; amount?: string }) {
        let data = await HttpClient.post(`/wallet/centaurus/promotional-balance/${balanceId}/refund`, payload);
        return data;
    }

    async getSignedUrlForCohort(fileName: string) {
        const data = await HttpClient.get("uploadImage/getSignedUrl", {
            params: { directory: "promotionalBalanceCohorts", fileName },
        });
        return data?.data as { putUrl: string; getUrl: string };
    }

    async uploadCohortFileToGCS(putUrl: string, file: File) {
        return axios.put(putUrl, file, { headers: { "Content-Type": "text/csv" } });
    }

    async createCohort(cohortName: string, sheetLink: string) {
        const data = await HttpClient.post("/wallet/centaurus/promotional-balance-cohort", {
            cohortName,
            sheetLink,
        });
        return data?.data;
    }

    async getCohorts(limit: number, offset: number) {
        const data = await HttpClient.get("/wallet/centaurus/promotional-balance-cohort", {
            params: { limit, offset, sort: JSON.stringify({ field: "createdAt", order: "DESC" }) },
        });
        const res = data?.data as { data: any[]; count: number };
        return { data: res.data, total: res.count };
    }
}